import { DataBean } from "../DataBean";

export class WorkActivityGroupUser extends DataBean {

  public async getWorkActivityGroupUserCatalogPorPropiedades(properties: any, maxRows?: number): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "java.util.List_getWorkActivityGroupUserCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getWorkActivityGroupUserRender(page: number, rows: number, props: any): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "com.advantage.shared.Report_getWorkActivityGroupUserRender_Number_Number_java.util.Map",
      [page, rows, props]
    );
  }

  public async deleteWorkActivityGroupUser(idworkactivitygroupuser: number): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "boolean_deleteWorkActivityGroupUser_Number",
      [idworkactivitygroupuser]
    );
  }

  public async updateWorkActivityGroupUser(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "com.advantage.processflow.bean.WorkActivityGroupUser_updateWorkActivityGroupUser_com.advantage.processflow.bean.WorkActivityGroupUser",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.advantage.processflow.bean.WorkActivityGroupUser",
        },
      ]
    );
  }
}
